const recaptchaScript = document.querySelector("script[data-recaptcha-sitekey]");
window.siteKey = recaptchaScript ? recaptchaScript.getAttribute("data-recaptcha-sitekey") : "";

// How this code snippet works:
// This logic overwrites the default behavior of `grecaptcha.ready()` to
// ensure that it can be safely called at any time. When `grecaptcha.ready()`
// is called before reCAPTCHA is loaded, the callback function that is passed
// by `grecaptcha.ready()` is enqueued for execution after reCAPTCHA is
// loaded.
if (typeof grecaptcha === "undefined") {
  grecaptcha = {};
}
grecaptcha.ready = function (cb) {
  if (typeof grecaptcha === "undefined") {
    // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
    // configuration. By default, any functions listed in its 'fns' property
    // are automatically executed when reCAPTCHA loads.
    const c = "___grecaptcha_cfg";
    window[c] = window[c] || {};
    (window[c].fns = window[c].fns || []).push(cb);
  } else {
    cb();
  }
};
const forms = document.querySelectorAll("form.recaptcha");
forms.forEach(form => form.addEventListener('submit', e => recaptchaSubmit(e, form)));
function appendSubmitterInput(form, submitter) {
  form.querySelectorAll('input[data-recaptcha-submitter="1"]').forEach(input => input.remove());
  if (!submitter || !submitter.name) {
    return;
  }
  const submitterInput = document.createElement("input");
  submitterInput.type = "hidden";
  submitterInput.name = submitter.name;
  submitterInput.value = submitter.value;
  submitterInput.setAttribute("data-recaptcha-submitter", "1");
  form.appendChild(submitterInput);
}
function recaptchaSubmit(e, form) {
  e.preventDefault();
  const submitter = e.submitter || form.querySelector('button[type="submit"][name], input[type="submit"][name]');
  appendSubmitterInput(form, submitter);
  let gRecaptchaResponse = form.querySelector('input[name="g-recaptcha-response"]');
  if (!gRecaptchaResponse) {
    gRecaptchaResponse = document.createElement("input");
    gRecaptchaResponse.type = "hidden";
    gRecaptchaResponse.name = "g-recaptcha-response";
    form.appendChild(gRecaptchaResponse);
  }
  if (typeof grecaptcha === "undefined" || typeof grecaptcha.execute !== "function" || typeof window.siteKey !== "string" || window.siteKey === "") {
    notifyRecaptchaError();
    return;
  }
  grecaptcha.ready(() => {
    grecaptcha.execute(window.siteKey, {
      action: "submit"
    }).then(token => {
      gRecaptchaResponse.value = token;
      form.submit();
    }).catch(() => {
      notifyRecaptchaError();
    });
  });
}
function notifyRecaptchaError() {
  if (typeof pubsub !== "undefined" && pubsub && typeof pubsub.trigger === "function") {
    pubsub.trigger("error", {
      errorMsg: "An error occurred during validation. Please try again."
    });
    return;
  }
  alert("An error occurred during validation. Please try again.");
}